/* istanbul ignore file */
import { Box, Typography } from '@mui/material';
import DateTimeDisplay from './DateTimeDisplay';
import useCountDown from './useCountDown';

const separator = (
  <Typography component="span" variant="body1">
    :
  </Typography>
);

const CountDownTimer = ({
  targetDate,
  hasExpiredNotice,
  shouldCountFromTargetDate = true,
  isExpired: isExpiredFromProps,
  showMonths = true,
  stopDatetime,
}: {
  targetDate: string;
  hasExpiredNotice?: boolean;
  shouldCountFromTargetDate?: boolean;
  isExpired?: boolean;
  showMonths?: boolean;
  stopDatetime?: string;
}) => {
  const countDown = useCountDown({ targetDate, shouldCountFromTargetDate, stopDatetime });

  if (!countDown) {
    return null;
  }

  const { months, days, hours, minutes, seconds, isExpired: isExpiredFromTimer } = countDown;
  const isExpired = isExpiredFromProps !== undefined ? isExpiredFromProps : isExpiredFromTimer;

  if (isExpired && hasExpiredNotice) {
    return (
      <Typography variant="body1" color="error">
        Expired!!!
      </Typography>
    );
  } else {
    return (
      <Box
        color={isExpired ? 'error' : 'inherit'}
        sx={{
          display: 'grid',
          gridTemplateColumns:
            !showMonths && !months ? '1fr 5px 1fr 5px 1fr 5px 1fr' : '1fr 5px 1fr 5px 1fr 5px 1fr 5px 1fr',
          gap: 0,
          width: !showMonths && !months ? 124 : 155,
        }}
      >
        {showMonths || !!months ? (
          <>
            <DateTimeDisplay type="Mths" value={months} hasMinus={isExpired} />

            {separator}
          </>
        ) : null}
        <DateTimeDisplay type="Days" value={days} />
        {separator}
        <DateTimeDisplay type="Hrs" value={hours} />
        {separator}
        <DateTimeDisplay type="Mins" value={minutes} />
        {separator}
        <DateTimeDisplay type="Secs" value={seconds} />
      </Box>
    );
  }
};

export default CountDownTimer;
